import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { INiveisRiscoResidual } from 'src/app/models/niveis-risco-residual.model';
import { NiveisRiscoResidualService } from 'src/app/services/niveis-risco-residual.service';
import { BaseFormComponent } from 'src/app/shared/components/base-form/base-form.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-risco-residual',
  templateUrl: './modal-risco-residual.component.html',
  styleUrls: ['./modal-risco-residual.component.scss']
})
export class ModalRiscoResidualComponent extends BaseFormComponent implements AfterViewInit, OnInit {

  model = {} as INiveisRiscoResidual;
  anoSelecionado: number;
  txtBtnConcluir: string;
  campoObrigatorio = false;
  atualizando = false;

  listData: any[] = []

  textoModal = 'Adicionar Classificação do Risco Residual'

  operadorList: any[] = [
    { id: '>=', nome: 'Maior ou Igual (>=)' },
    { id: '<=', nome: 'Menor ou Igual (<=)' },
    { id: '>', nome: 'Maior (>)' },
    { id: '<', nome: 'Menor (<)' },
    { id: '!=', nome: 'Diferente (!=)' },
    { id: '=', nome: 'Igual (=)' }
  ];

  constructor(
    route: ActivatedRoute,
    private dialogRef: MatDialogRef<ModalRiscoResidualComponent>,
    public toastr: ToastrService,
    localeService: BsLocaleService,
    router: Router,
    private serviceRiscoResidual: NiveisRiscoResidualService,
    public matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    super(route, toastr, router, localeService, matDialog);
    this.model.id = data.id;
    this.model.nome = data?.nome;
    this.model.operador = data?.operador;
    this.model.valor = data?.valor;
    this.model.operador_1 = data?.operador_1;
    this.model.valor_1 = data?.valor_1;
    this.model.ativo = data?.ativo;
    this.model.criteriosAvaliacaoRiscosId = data?.criteriosAvaliacaoRiscosId;
    this.listData = data?.listData

    if (!this.model.id || this.model.id == 0) {
      this.atualizando = false;
      this.txtBtnConcluir = "Inserir"
    }
    else {
      this.atualizando = true;
      this.txtBtnConcluir = "Atualizar"
      this.textoModal = 'Editar Classificação do Risco Residual'
    }
  }

  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
  }

  concluir() {

    let dados = this.listData.find(o => o.nome == this.model.nome)

    if (dados) {
      this.exibirMensagemErro('Nome da Classificação de Risco já adicionado! Informe outro nome para prosseguir')
      return
    }

    if (this.atualizando) {
      this.serviceRiscoResidual.atualizar(this.model).then((res) => { this.dialogRef.close(true); })
    } else {
      this.model.ordem = this.proximaOrdem(this.listData)
      this.serviceRiscoResidual.inserir(this.model).then((res) => { this.dialogRef.close(true); })
    }
  }

  cancelar() {
    this.dialogRef.close(false);
  }

  proximaOrdem(array: any[]): number {
    if (array.length === 0) {
      return 1;
    }

    const maxOrdem = array.reduce((max, item) => {
      return item.ordem > max ? item.ordem : max;
    }, -Infinity);

    return maxOrdem + 1;
  }
}
